import type { DocumentUploadFormInput } from "web_myplann/Portfolio/Forms/DocumentUploadForm/documentUploadFormSchema";

export const DOCUMENT_UPLOAD_FORM_DEFAULT_VALUES: DocumentUploadFormInput = {
	pickedFile: null,
	name: "",
	folder: null,
	linkedItem: null,
};
